export const getUrlForPagination = (pathname: string) => (pageNumber?: number) => {
  try {
    const url = new URL(pathname);
    if (pageNumber) url.searchParams.set('p', pageNumber.toString());
    return `${url.toString()}`;
  } catch (error) {
    console.error(error);
  }
};
